import { FC } from 'react';

const EmailChangedConfirmationPage: FC = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 max-w-full mx-auto w-[1280px] px-4 py-10">
      <h2 className="font-bold text-2xl">Email changed</h2>
      <p>Your email has been changed successfully. You can now log in with your new email.</p>
    </div>
  );
};

export default EmailChangedConfirmationPage;
